import { types } from 'mobx-state-tree'

import { ReferenceFreightieOrUser } from '../Actors'
import { FORTO_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { COMPANY_NAME } from '../constants'
import { IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'
import { Activity, ActorActivity, IActivity } from './Activity'

type SubscriptionAction = 'joined' | 'left'
export interface ISubscriptionActivity extends IActivity, ActorActivity {
  action: SubscriptionAction
}

const actionTermMap = {
  joined: 'activity-feed_subscription_activity_joined',
  left: 'activity-feed_subscription_activity_left',
}

export const SubscriptionActivity = types
  .compose(
    'SubscriptionActivity',
    Activity,
    types.model({
      actor: ReferenceFreightieOrUser,
      action: types.string, // 'left' | 'joined'
    })
  )
  .preProcessSnapshot((snapshot) => {
    const { freightieAuthor_id, userAuthor_id } = snapshot
    return {
      ...snapshot,
      actor: freightieAuthor_id || userAuthor_id,
    }
  })
  .views((self) => ({
    get avatarType(): TAvatarType {
      return FORTO_AVATAR
    },
    get messageContent(): IActivityMessageSection[] {
      return [
        {
          type: TEXT,
          content: self.actor ? self.actor.name : '',
        },
        {
          type: TEXT,
          content: !self.actor ? 'activity-feed_deleted_user' : '',
          translate: true,
        },
        { type: TEXT, content: ' ' },
        {
          type: TEXT,
          content: actionTermMap[self.action],
          translate: true,
        },
      ]
    },
    get title(): IActivityTitle {
      return { text: COMPANY_NAME }
    },
  }))
